// Which phone and browser a user agent belongs to. The location help uses it to show the steps for
// the browser in hand (an iPhone's Chrome or an app's built-in browser has no Safari "aA" button),
// and Manage Bookings uses it to say where a customer's location failed.

// Apps that open links in their own browser. Location there depends on the app, and often fails.
const IN_APP = [
  [/Instagram/i, "Instagram"],
  [/FBAN|FBAV|FB_IAB|FBIOS/i, "Facebook"],
  [/WhatsApp/i, "WhatsApp"],
  [/LinkedInApp/i, "LinkedIn"],
  [/Snapchat/i, "Snapchat"],
  [/GSA\//, "Google app"],
  [/Twitter/i, "X"],
  [/\bLine\//, "LINE"],
];

const IOS_BROWSERS = [
  [/CriOS/, "Chrome"],
  [/FxiOS/, "Firefox"],
  [/EdgiOS/, "Edge"],
  [/OPiOS|OPT\//, "Opera"],
];

const ANDROID_BROWSERS = [
  [/SamsungBrowser/, "Samsung Internet"],
  [/EdgA/, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/Firefox/, "Firefox"],
  [/Chrome/, "Chrome"],
];

const DESKTOP_BROWSERS = [
  [/Edg\//, "Edge"],
  [/OPR\//, "Opera"],
  [/Firefox/, "Firefox"],
  [/Chrome/, "Chrome"],
  [/Safari/, "Safari"],
];

const firstMatch = (list, ua) => (list.find(([pattern]) => pattern.test(ua)) || [])[1];

/**
 * { ios, android, device, osVersion, browser, inApp, label } for a user agent. `maxTouchPoints`
 * spots an iPad, whose Safari says it is a Mac; pass it when describing the current device.
 */
export function describeBrowser(userAgent, maxTouchPoints = 0) {
  const ua = String(userAgent || "");
  const ipadAsMac = /Macintosh/.test(ua) && maxTouchPoints > 1;
  const ios = /iPhone|iPad|iPod/.test(ua) || ipadAsMac;
  const android = !ios && /Android/.test(ua);
  const device = ios
    ? /iPad/.test(ua) || ipadAsMac ? "iPad" : "iPhone"
    : android ? "Android" : /Windows/.test(ua) ? "Windows" : /Macintosh/.test(ua) ? "Mac" : "Other";
  const osVersion = ios
    ? (ua.match(/OS (\d+)[_.](\d+)/) || []).slice(1, 3).join(".")
    : android ? (ua.match(/Android (\d+(?:\.\d+)?)/) || [])[1] || "" : "";

  let browser = firstMatch(IN_APP, ua);
  let inApp = Boolean(browser);
  if (!browser && ios) {
    browser = firstMatch(IOS_BROWSERS, ua);
    // Safari and the other iPhone browsers say "Safari/"; an app's own browser leaves it out.
    if (!browser && /Safari\//.test(ua)) browser = "Safari";
    if (!browser) {
      browser = "an app";
      inApp = true;
    }
  }
  if (!browser && android) {
    // "; wv)" marks an app's built-in browser on Android.
    if (/; wv\)/.test(ua)) {
      browser = "an app";
      inApp = true;
    } else {
      browser = firstMatch(ANDROID_BROWSERS, ua);
    }
  }
  if (!browser) browser = firstMatch(DESKTOP_BROWSERS, ua) || "Unknown browser";

  const where = ios
    ? `${device}${osVersion ? ` iOS ${osVersion}` : ""}`
    : android ? `Android${osVersion ? ` ${osVersion}` : ""}` : device;
  const label = inApp ? `${browser === "an app" ? "An app's" : `${browser}'s`} browser · ${where}` : `${browser} · ${where}`;
  return { ios, android, device, osVersion, browser, inApp, label };
}

/** describeBrowser for the device this page is open on. */
export function currentBrowser() {
  if (typeof navigator === "undefined") return describeBrowser("");
  return describeBrowser(navigator.userAgent, navigator.maxTouchPoints || 0);
}
